import { NgModule } from '@angular/core';

import { InvoiceAnalysisComponent }      from './invoice.analysis.component';
import { InvoiceContactStatusComponent } from './contact-status/invoice.contact-status.component';
import { InvoiceReferenceComponent }     from './invoice.reference.component';
import { InvoiceStatusPipe }             from './invoice.status.pipe';
import { InvoiceTypePipe }               from './invoice.type.pipe';
import { SharedModule }                  from '../shared/shared.module';

@NgModule({
  declarations: [
    InvoiceAnalysisComponent,
    InvoiceContactStatusComponent,
    InvoiceReferenceComponent,
    InvoiceStatusPipe,
    InvoiceTypePipe
  ],
  entryComponents: [
    InvoiceAnalysisComponent,
    InvoiceContactStatusComponent,
    InvoiceReferenceComponent
  ],
  exports: [
    InvoiceAnalysisComponent,
    InvoiceContactStatusComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    InvoiceStatusPipe,
    InvoiceTypePipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'invoiceStatus',
      useClass: InvoiceStatusPipe
    },
    {
      provide : 'invoiceType',
      useClass: InvoiceTypePipe
    }
  ]
})
export class InvoicesModule {}